var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosedEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 824,
    y: 300,
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-824 -300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.395 302.55 841.408 302.55C841.614 302.551 841.813 302.659 841.924 302.85L844.534 307.371 844.576 307.459 844.592 307.513C844.629 307.618 844.65 307.732 844.65 307.85L844.65 320.45C844.65 321.003 844.202 321.45 843.65 321.45L828.35 321.45C827.798 321.45 827.35 321.003 827.35 320.45L827.35 307.85C827.35 307.719 827.375 307.594 827.421 307.479L827.442 307.425 827.47 307.371 830.08 302.85C830.199 302.644 830.421 302.536 830.643 302.551L830.667 302.55 841.395 302.55ZM843.45 308.05 828.55 308.05 828.55 320.25 843.45 320.25 843.45 308.05ZM838.9 311.05C839.231 311.05 839.5 311.319 839.5 311.65 839.5 311.982 839.231 312.25 838.9 312.25L833.1 312.25C832.769 312.25 832.5 311.982 832.5 311.65 832.5 311.319 832.769 311.05 833.1 311.05L838.9 311.05ZM841.057 303.75 830.946 303.75 829.156 306.85 842.848 306.85 841.057 303.75Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEvents);
export default __webpack_public_path__ + "static/media/closed_events.9cd5761c46b51b130a1eafbeb696417b.svg";
export { ForwardRef as ReactComponent };